import React,{cloneElement, useMemo} from 'react';
import { useTable } from 'react-table';
import Data from './Data.json';
import {COLUMNS} from './Columns';
import './TableStyle.css';

export const BasicTable=()=>{
    const columns=useMemo(()=>COLUMNS,[])
    const data=useMemo(()=>Data,[])

  // const tableInstance= useTable({
    //    columns,
      //  data
    //})
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    }=useTable({
        columns,
        data
    })
    return 
    (
        <table{...getTableProps()}>
            <tbody{...getTableBodyProps()}>
            {
                rows.map((row)=>{
                    prepareRow(row)
                    return
                    (
                        <tr {...row.getRowProps()}>
                            {row.cells.map((cell)=>{
                                return   <td {...cell.getCellProps()}>
                                    {cell.render('Cell')}
    
                                </td>
                                
                            })}
                    </tr>
                    )
                })
            }
            </tbody>
        </table>
    )
}